import { PLATFORM } from '@ezugi/constants';

import { DeviceInfo } from './deviceInfo';

export const getPlatform = () => (DeviceInfo.isMobile && PLATFORM.PHONE)
|| (DeviceInfo.isTablet && PLATFORM.TABLET) || PLATFORM.DESKTOP;
